import { render, staticRenderFns } from "./IbxCardMeta.vue?vue&type=template&id=3ff5273e"
import script from "./IbxCardMeta.vue?vue&type=script&lang=ts"
export * from "./IbxCardMeta.vue?vue&type=script&lang=ts"
import style0 from "./IbxCardMeta.vue?vue&type=style&index=0&id=3ff5273e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports